import Accordion from './components/GutenbergAccordion.vue';
import InitLazyComponent from 'Modules/InitLazyComponent';

const accordions = document.querySelectorAll('.gutenberg-accordion');
const initLazyComponent = new InitLazyComponent({
  selectors: accordions,
  components: { Accordion },
  template: '<Accordion />',
});

initLazyComponent.init();
